<template>
	<div>
		<div>
			<b-form-checkbox v-model="privacy" class="font-weight-extra-bold" @input="emitChangeEvent">
				<template v-if="agbShort">
					Ich akzeptiere die <a href="/info/nutzungsbedingungen" target="_blank">Nutzungsbedingungen</a>.
				</template>
				<template v-else>
					Ich akzeptiere die <a href="/info/nutzungsbedingungen" target="_blank">Nutzungsbedingungen</a>
					und <a href="/info/agb" target="_blank">AGB</a>.
				</template>
			</b-form-checkbox>
		</div>
		<div class="mt-2">
			Die <a href="/info/datenschutz" target="_blank">Datenschutzerklärung</a> findest du hier.
		</div>
	</div>
</template>

<script>
export default {

	props: {
		agbShort: {
			type: Boolean,
			required: false,
			default: false,
		},
		value: {
			type: Boolean,
			required: false,
		},
	},

	data ()
	{
		return {
			privacy: this.value,
		};
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', this.privacy);
		}
	}
}
</script>
